import { IUsersProps } from "../../Hooks/Users";
import { get } from "../restClient";

export const getUsers = () => {
  return get<IUsersProps[]>("users");
};
